import axios from 'axios';

export const usersApi = {
  list() {
    return axios.get('/api/users').then((r) => r.data);
  },

  getOne(id) {
    return axios.get(`/api/users/${id}`).then((r) => r.data);
  },

  create(body) {
    return axios.post('/api/users', body).then((r) => r.data);
  },

  update(id, body) {
    return axios.put(`/api/users/${id}`, body).then((r) => r.data);
  },

  delete(id) {
    return axios.delete(`/api/users/${id}`).then((r) => r.data);
  },
};
